import React from 'react';
import { useKeenSlider } from "keen-slider/react.js";
import { ProductCard } from './ProductCard';

type CarouselProduct = {
  id: string;
  name: string;
  price: string;
  originalPrice?: string | null;
  discount?: number | null;
  image: string;
  url?: string;
};

interface ProductCarouselProps {
  products: CarouselProduct[];
  onProductClick?: (product: CarouselProduct, index: number) => void;
}

export const ProductCarousel: React.FC<ProductCarouselProps> = ({
  products,
  onProductClick
}) => {
  const [sliderRef] = useKeenSlider<HTMLDivElement>({
    mode: "free-snap",
    renderMode: "performance",
    rubberband: true,
    slides: {
      perView: "auto",
      spacing: 6,
    },
    breakpoints: {
      "(min-width: 640px)": { slides: { perView: "auto", spacing: 6 } },
      "(min-width: 768px)": { slides: { perView: "auto", spacing: 8 } },
      "(min-width: 1024px)": { slides: { perView: "auto", spacing: 8 } },
    },
  });

  return (
    <div id="otc-products-carousel" ref={sliderRef} className="keen-slider side-menu-products-carousel">
      {products.map((product, index) => (
        <ProductCard
          key={product.id}
          product={product}
          onProductClick={onProductClick ? (p) => onProductClick(p, index) : undefined}
        />
      ))}
    </div>
  );
};
